import InfiniteLoader from './InfiniteLoader';

export default InfiniteLoader;
